import { HStack, Stack, Button, Text, useToast } from "@chakra-ui/react";
import { CurrencyText } from "../../../shared/ui";
import { isPlanoBloqueado } from "../../../shared/api/planoBloqueado";
import { apiErrorMessage } from "../../../shared/api/apiErrorMessage";
import { useBulkUpdateShiftStatusMutation } from "../hooks/useBulkUpdateShiftStatusMutation";
import { BULK_STATUS_ACTIONS } from "../utils/bulkStatusActions";

// Barra de ações em lote sobre um conjunto de plantões (os selecionados em Recebíveis, ou
// todos os do vínculo/mês da comprovação). Cada botão mostra quantos plantões do conjunto
// aceitam aquela ação e envia só esses — os demais ficam como estão.
export default function BulkStatusBar({ shifts, summary, onDone, extraActions }) {
  const toast = useToast();
  const mutation = useBulkUpdateShiftStatusMutation();
  const total = shifts.reduce((acc, shift) => acc + shift.valor, 0);

  const apply = (action) => {
    const ids = shifts.filter(action.isEligible).map((shift) => shift.id);
    mutation.mutate(
      { ids, acao: action.acao },
      {
        onSuccess: (result) => {
          toast({ title: action.successTitle(result?.atualizados ?? ids.length), status: "success", duration: 4000 });
          onDone?.();
        },
        onError: (error) => {
          if (isPlanoBloqueado(error)) return;
          toast({
            title: "Não foi possível atualizar os plantões",
            description: apiErrorMessage(error),
            status: "error",
            duration: 5000,
            isClosable: true,
          });
        },
      }
    );
  };

  return (
    <Stack
      direction={{ base: "column", md: "row" }}
      justify="space-between"
      align={{ base: "stretch", md: "center" }}
      spacing={3}
      p={3}
      borderRadius="lg"
      bg="accent-subtle"
      border="1px solid"
      borderColor="accent-subtle-border"
    >
      <Text fontSize="sm" color="accent-text-strong">
        {summary ?? `${shifts.length} plantão(ões) selecionado(s)`} · <CurrencyText value={total} />
      </Text>
      <HStack spacing={2} flexWrap="wrap">
        {BULK_STATUS_ACTIONS.map((action) => {
          const count = shifts.filter(action.isEligible).length;
          const Icon = action.icon;
          return (
            <Button
              key={action.acao}
              size="sm"
              variant={action.variant}
              leftIcon={<Icon size={14} />}
              isDisabled={count === 0 || mutation.isPending}
              isLoading={mutation.isPending && mutation.variables?.acao === action.acao}
              onClick={() => apply(action)}
            >
              {action.label} ({count})
            </Button>
          );
        })}
        {extraActions}
      </HStack>
    </Stack>
  );
}
